var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.672 11.692C3.54133 11.692 2.67733 11.3933 2.08 10.796C1.48267 10.188 1.184 9.292 1.184 8.108V5.932C2.176 5.932 2.96533 5.90533 3.552 5.852C4.13867 5.788 4.57067 5.676 4.848 5.516C5.136 5.34533 5.32267 5.084 5.408 4.732C5.504 4.38 5.552 3.91067 5.552 3.324V1.068H7.584V3.276C7.584 3.96933 7.50933 4.57733 7.36 5.1C7.21067 5.612 6.96533 6.03867 6.624 6.38C6.29333 6.71067 5.84533 6.96133 5.28 7.132C4.71467 7.292 4.02133 7.372 3.2 7.372V8.348C3.2 8.84933 3.30667 9.26 3.52 9.58C3.73333 9.88933 4.10667 10.044 4.64 10.044C5.152 10.044 5.51467 9.89467 5.728 9.596C5.94133 9.29733 6.048 8.88667 6.048 8.364H8.032C8.01067 9.42 7.71733 10.2413 7.152 10.828C6.58667 11.404 5.76 11.692 4.672 11.692ZM0.704 4.46V3.084H9.264V4.46H0.704ZM0.704 1.788V0.299999H9.264V1.788H0.704Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.a0d1c7d01f08995ef6a222ddd4303d81.svg";
export { ForwardRef as ReactComponent };